/**
 * @desc 更换手机号
 */
import { UserEntity, ChangePhoneForm } from '@eastcoal/api/auth/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type ChangeUserPhoneParameter = ChangePhoneForm

const method = 'PUT'
const url = '/auth/user/phone'

export const changeUserPhoneApi = (
  data?: ChangeUserPhoneParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<UserEntity>({
    method,
    url,
    data,
    ...config
  })
}

changeUserPhoneApi.method = method
changeUserPhoneApi.url = url
